module.exports = __webpack_public_path__ + "static/media/DSC_0145.24ef06e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0145.jpg
// module id = 559
// module chunks = 0